module.exports = __webpack_public_path__ + "img/me.76c434a6.svg";